import {Component, input} from '@angular/core';
import {BasicTaDetails} from '../../../api';

/**
 * Renders a paperclip in the TA list tables when the TA has supporting files attached, and
 * nothing otherwise.
 */
@Component({
  selector: 'attachment-indicator',
  templateUrl: './attachment-indicator.component.html',
})
export class AttachmentIndicatorComponent {
  taDetails = input<BasicTaDetails | null | undefined>();
}
